// src/services/passwordService.ts

import { apiClient } from "./apiClient";

/**
 * Self-service password change (requires current password).
 */
export const changePassword = async (
  currentPassword: string,
  newPassword: string
): Promise<void> => {
  await apiClient.put("/api/profile/me/password", { currentPassword, newPassword });
};

/**
 * Request a password reset email.
 * Always resolves — the backend returns 200 regardless of whether the email exists,
 * to prevent account enumeration. The caller should show a generic success message.
 */
export const requestPasswordReset = async (email: string): Promise<void> => {
  await apiClient.post("/api/auth/forgot-password", { email });
};

/**
 * Complete the password reset using the token from the email link.
 * Throws if the token is invalid or expired (backend returns 400).
 */
export const resetPassword = async (
  token: string,
  newPassword: string
): Promise<void> => {
  await apiClient.post("/api/auth/reset-password", { token, newPassword });
};